<template lang="pug">
  include /mixins
  row(
    :justify="['center', 'between-xl']"
    appearance='spaced'
  )
    cell(
      cols='12 3-md 6-xl 3-mac 3-fhd'
      v-for='(filter, key) in filters'
      :key='key'
      v-if="filter.type !== 'NumberFilter' && filter.label !== 'District' && filter.type !== 'OrderingFilter'"
    )
      template
        tag(
          :tag='$options.widgetsMap[filter.type]'
          :parameters="parameters"
          :value="value[key]"
          :filter-name="key"
          :disabled="disabled"
          :filter="filter"
          @input="updateValue(key, $event)"
        )
    cell(cols='12 8-md')
      tag(
        :tag="$options.widgetsMap.NumberFilter",
        :available="available",
        :range='range'
        :disabled="disabled",
        :filter="prices",
        @input="updateMultipleValues('_storage', $event)",
      )
    cell(cols='12 4-md')
      row(justify='end')
        cell
          portal-target(name='clear-filter')
</template>

<script>
import UiMixin from './mixins/UiMixin'

export default {
  mixins: [UiMixin],

  props: [
    'range',
    'all',
    'disabled',
    'value',
    'filters',
    'available',
    'pagination',
    'additionalResource',
  ],

  data() {
    return {
      prices: {
        min: 0,
        max: 0,
      },
      search: '',
    }
  },
  mounted() {},
  watch: {
    filters: {
      deep: true,
      handler(nval) {
        this.createPrices(nval)
      },
    },
  },
  methods: {
    createPrices(data) {
      this.prices.min = data.min_storage.initial
      this.prices.max = data.max_storage.initial
    },
  },
}
</script>
